// make a basic react component that just says hello world
import React, { useEffect } from "react";
import ProfileUserMetadata from "./ProfileUserMetadata";
import DeleteAccount from "./DeleteAccount";

function Account() {
  useEffect(() => {
    document.title = "Account Settings | Brev.dev";
  }, []);

  return (
    <>
      <ProfileUserMetadata />
      <DeleteAccount />
    </>
  );
}

export default Account;
